import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from './../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../AmLeader';
import Dropdown from '../Dropdown';


import { MDBContainer, MDBRow, MDBCol, MDBStepper, MDBStep, MDBBtn, MDBCard, MDBCardBody, MDBInput } from "mdbreact";
import { registrationRequest, loginReset } from '../../../redux/reducers/login';

import { COLORS,commonStyles } from '../../../styles/styles';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';


const FourthPageModal = ({ classes, form, pristine, previousPage, submitting, login, ...props }) => {
  const { handleSubmit, dropdowns } = props;
  return (
    // <div className={classes.regFormWrapper}>
    //   <h4 className={classes.pageNo}>Page 2 of 5</h4>
    //   <form onSubmit={handleSubmit}>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="maritalStatus" label="Marital Status" component={Dropdown} options={dropdowns.dropdowns.maritalStatus}/>
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field name="residenceStatus" label="Residence Status" component={Dropdown} options={dropdowns.dropdowns.residenceStatus}/>
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="address" label="Home Address" component={TextField}  />
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //       <Field name="city" label="City" component={TextField}  />
    //     </div>
    //     <div className={`${classes.halfField} ${classes.firstInRow}`}>
    //       <Field name="code" label="Postal Code" component={TextField}  />
    //     </div>
    //     <div className={`${classes.halfField}`}>
    //       <Field name="telephone" label="Telephone" component={TextField}  />
    //     </div>
    //     <div className={classes.halfField}>
    //       <Field name="fax" label="Fax (Optional)" component={TextField}  />
    //     </div>
    //     <div>
    //       <div className={classes.halfField}>
    //         <button variant="contained"
    //           className={`${classes.defaultButton} ${classes.shortButton}`} type="button"  onClick={previousPage}>Previous</button>
    //       </div>
    //       <div className={classes.halfField}>
    //         <button variant="contained"
    //           className={`${classes.defaultButton} ${classes.shortButton}`} type="submit" >Next</button>
    //       </div>
    //     </div>
    //   </form>
    // </div>
    <form className="w-100" onSubmit={handleSubmit}>
      <MDBCol md="12">
      <MDBRow>
        
      </MDBRow>
      <MDBRow>
        <MDBCol md="12">
        {dropdowns.dropdowns.urbanRural && <Field name="urbanRural" label="Urban or Rural" component={Dropdown}  options={dropdowns.dropdowns.urbanRural}  depth={10012}/>}
        </MDBCol>
       
      </MDBRow>
      <MDBRow>
        <MDBCol md="12">
        {dropdowns.dropdowns && <Field name="address" label="Home Address" component={TextField}  />}
        </MDBCol>
      </MDBRow>
      <MDBRow>
        <MDBCol md="12">
        {dropdowns.dropdowns && <Field name="city" label="City" component={TextField}  />}
        </MDBCol>
        
      </MDBRow>
      <MDBRow>
        <MDBCol md="12">
        {dropdowns.dropdowns.municipleAreas && <Field name="conMunicipalAreaID" label="Municipality" component={Dropdown}  options={dropdowns.dropdowns.municipleAreas}  depth={10009}/>}
        </MDBCol>
       
      </MDBRow>
      <MDBRow>
        <MDBCol md="12">
     
       <Field name="code2" label="Search for Suburb (5 char)" component={TextField} depth={10008} />
        </MDBCol>
       
      </MDBRow>
      <MDBRow>
        <MDBCol md="12">
        {dropdowns.dropdowns.provinces && <Field name="conProvinceID" label="Province" component={Dropdown}  options={dropdowns.dropdowns.provinces}  depth={10007}/>}
        </MDBCol>
       
      </MDBRow>
     
      <MDBRow>
      <MDBCol md="12">
        <Field name="code" label="Postal Code" component={TextField}  />
        </MDBCol>
      </MDBRow>
   
     
      <MDBRow className="mt-4">
              <MDBCol size="6">
                <MDBBtn 
                    right
                    size="md"
                    className='mt-0 mb-2 float-left danger-color-dark'
                    action
                    onClick={previousPage}
                    type="button">
                  PREVIOUS
                </MDBBtn>
              </MDBCol>
              <MDBCol size="6">
                <MDBBtn color="success"
                    right
                    size="md"
                    className='ml-3 mr-2 mt-0 mb-2 float-right'
                    action
                    type="submit">
                  NEXT
                </MDBBtn>
              </MDBCol>
            </MDBRow>

    </MDBCol>
      <ReactCSSTransitionGroup
              transitionName="fade"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}>{login.fetchingPageReg && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
              <div style={{position:'absolute', top:"40%", width:'100%'}}>
            <ScaleLoader
             
             height={35}
             width={4}
             radius={2}
             margin='2px'
            color={COLORS.cornerstoneRed}
             loading={true}
           />
           </div>
            </div>}</ReactCSSTransitionGroup>
    </form>
  ); 
}



FourthPageModal.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  login: PropTypes.instanceOf(Object),
  form: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
  dropdowns: state.dropdownsReducer,
  initialValues: state.loginReducer.user.extendedInfo
});
const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  loginReset: () => dispatch(loginReset()),
});


const styles = () => ({
  ...commonStyles,
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '2%',
  },
  label: {
    color: '#e84848',
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',

  }
});

export default compose(
  reduxForm({ form: 'registration',
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  enableReinitialize : true,   
  validate
 }),
  connect(mapStateToProps, mapDispatchToProps),
  
 
  withStyles(styles),
  lifecycle({
    componentWillMount() {
        var obj = {};
        obj.address = this.props.initialValues.Address;
        obj.city = this.props.initialValues.City
        obj.conProvinceID = this.props.initialValues.conProvinceID
        obj.conMunicipalAreaID = this.props.initialValues.conMunicipalAreaID
        obj.code = this.props.initialValues.Code
        this.props.initialize(obj)
     
      
    }
  }),
)(FourthPageModal);
